export default (state = {}, action) => {
  switch (action.type) {
    case 'CALENDARS_EVENTS_SET':
      state[action.gameMode] = action.events;
      return state;
    default:
      return state;
  }
};
